import { trackGoogleAdsConversion } from './googleAds';

/**
 * WhatsApp de la escuela (el mismo número de extraescolares y vecinos).
 * Sustituye al chat de Intercom desde el 27/09/2026.
 */
export const WHATSAPP_PHONE = '616975363';
/** El mismo número tal como se muestra en la web. */
export const WHATSAPP_PHONE_DISPLAY = '616 975 363';

/** Enlace wa.me con el mensaje ya escrito. */
export const whatsappUrl = (message?: string) =>
  `https://wa.me/34${WHATSAPP_PHONE}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

// Espera activa de una apertura en la misma pestaña (ventana bloqueada): evita contar varias conversiones
let yendo = false;

/**
 * Abre un chat de WhatsApp con el mensaje ya escrito, en una pestaña nueva (en el móvil abre la app).
 * Cuenta la conversión de Google Ads si la persona aceptó las cookies (ver cookieConsent.ts).
 */
export const openWhatsApp = (message?: string) => {
  if (typeof window === 'undefined') return;
  const url = whatsappUrl(message);
  // window.open primero, dentro del clic. Sin 'noopener' en las opciones: con él devuelve siempre null
  // y no se sabría si se bloqueó
  const nueva = window.open(url, '_blank');
  if (nueva) {
    try {
      nueva.opener = null;   // aislar la pestaña nueva antes que nada
    } catch {
      // algún navegador no deja tocar opener: la pestaña ya está abierta
    }
    trackGoogleAdsConversion();
  } else if (!yendo) {
    // Ventana bloqueada (navegadores integrados en apps): misma pestaña, después de registrar la conversión.
    // 'yendo' evita que varios toques durante la espera cuenten varias conversiones
    yendo = true;
    trackGoogleAdsConversion(() => {
      yendo = false;   // si la app abre WhatsApp y la página sigue aquí, el botón vuelve a funcionar
      window.location.href = url;
    });
  }
};

/** El botón flotante no sale en /admin ni en /vecinos (la campaña de la carta tiene sus propios WhatsApp). */
export const ocultarBotonWhatsApp = (pathname: string) => {
  const ruta = pathname.toLowerCase();   // React Router no distingue mayúsculas: /Vecinos también es la landing
  return ruta.startsWith('/admin') || /(^|\/)vecinos\/?$/.test(ruta);
};

/**
 * Mensajes ya escritos según el contexto, por idioma
 */
export const WHATSAPP_MESSAGES: Record<string, Record<string, string>> = {
  bookVisit: {
    es: 'Hola, me gustaría reservar una visita para conocer la escuela',
    en: 'Hi, I would like to book a visit to see the school',
    pt: 'Olá, gostaria de agendar uma visita para conhecer a escola',
    fr: 'Bonjour, je voudrais réserver une visite pour découvrir l\'école'
  },
  question: {
    es: 'Hola, tengo una consulta sobre la escuela',
    en: 'Hi, I have a question about the school',
    pt: 'Olá, tenho uma pergunta sobre a escola',
    fr: 'Bonjour, j\'ai une question sur l\'école'
  }
};
